import { Box, styled } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';

export const styles = {
  ImageSkeleton: styled(Skeleton, {
    height: 'calc($23 * 5)',
    width: '100%',
    backgroundColor: '$nonInteractiveAltAuxiliar',
  }),
  ImageWrapper: styled(Box, {
    borderRadius: '$medium',
    overflow: 'hidden',
    margin: '$10 0 0',
    maxHeight: 'calc($23 * 5)',

    img: {
      width: '100%',
    },
  }),
};

export default styles;
